import { LoadedProps, RouteLoadProps, errRedirect } from '@components/router';
import { defCalRoute } from '../common';
import { getAiInterview } from './local-data';
import { CalendarLandingPage } from '../landing-page';
import { WelcomeEmailModal } from '../page-builder/welcome-modal';
import { rpx } from 'client/lib/rpx-client';
import { generateInitialContent } from '../page-builder/initial-content';

async function load({ auth, params }: RouteLoadProps) {
  if (params.code) {
    // Provision the user's CoachMira account...
    const user = await rpx.ruzcal.oneClickAutoLogin({ resetCode: params.code });
    auth.setUser(user);
    // Save the AI content...
    const aiState = getAiInterview();
    if (aiState.aiData) {
      const content = generateInitialContent({
        userId: user.id,
        aiData: aiState.aiData,
        domain: location.host,
      });
      // This needs to be first because saveCalendarPageContent also
      // provisions the session user.
      await rpx.ruzcal.saveCalendarPageContent({
        content,
      });
      await rpx.aiInterview.saveInterview({
        messages: aiState.messages,
        sections: aiState.profile?.sections || {},
      });
    }
    throw errRedirect('/calendar/page-builder?modal=confirmed', true);
  }

  const state = getAiInterview(auth.user?.name);
  if (!state.aiData) {
    throw errRedirect('/interview');
  }
  return {
    name: state.name,
    landingPage: generateInitialContent({
      userId: auth.user?.id,
      aiData: state.aiData,
      domain: location.host,
    }),
  };
}

export const route = defCalRoute({ Page, hideChat: true, load, isPublic: true });

export function Page({ state }: LoadedProps<typeof load>) {
  return (
    <>
      <div class="blur-[2px] grayscale-50 opacity-80">
        <CalendarLandingPage hostId={undefined} content={state.landingPage} isPublished />
      </div>
      <WelcomeEmailModal userName={state.name} />
    </>
  );
}
